module.exports = __webpack_public_path__ + "0b250ead5f99c7ec478993f92180fe08.svg";